var _defs, _path, _rect, _path2, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankingDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12550",
    "data-name": "Group 12550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.694,
    height: 33.903,
    viewBox: "0 0 37.694 33.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 37.694,
    height: 33.903,
    fill: "#010101"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11077",
    "data-name": "Path 11077",
    d: "M18.847,0,0,8.194.643,9.672l18.2-7.915,18.2,7.915.643-1.477Z",
    transform: "translate(0 0)",
    fill: "#010101"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3510",
    "data-name": "Rectangle 3510",
    width: 35.441,
    height: 1.611,
    transform: "translate(1.127 11.35)",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11078",
    "data-name": "Path 11078",
    d: "M3.01,34.2H1.4V18.091H7.843V30.978H6.232V19.7H3.01Z",
    transform: "translate(-0.272 -3.519)",
    fill: "#010101"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3511",
    "data-name": "Rectangle 3511",
    width: 27.386,
    height: 1.611,
    transform: "translate(5.154 29.07)",
    fill: "#010101"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3512",
    "data-name": "Rectangle 3512",
    width: 35.441,
    height: 1.611,
    transform: "translate(1.127 32.292)",
    fill: "#010101"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12363",
    "data-name": "Group 12363",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12362",
    "data-name": "Group 12362",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11079",
    "data-name": "Path 11079",
    d: "M22.621,11.535a3.222,3.222,0,1,1,3.222-3.222,3.225,3.225,0,0,1-3.222,3.222m0-4.833a1.611,1.611,0,1,0,1.611,1.611A1.613,1.613,0,0,0,22.621,6.7",
    transform: "translate(-3.774 -0.99)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3513",
    "data-name": "Rectangle 3513",
    width: 2.416,
    height: 1.611,
    transform: "translate(1.932 18.599)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3514",
    "data-name": "Rectangle 3514",
    width: 2.416,
    height: 1.611,
    transform: "translate(1.932 22.626)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3515",
    "data-name": "Rectangle 3515",
    width: 2.416,
    height: 1.611,
    transform: "translate(1.932 26.654)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11080",
    "data-name": "Path 11080",
    d: "M43.843,34.2H42.232V19.7H39.01V30.978H37.4V18.091h6.444Z",
    transform: "translate(-7.275 -3.519)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3516",
    "data-name": "Rectangle 3516",
    width: 2.416,
    height: 1.611,
    transform: "translate(33.345 18.599)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517",
    "data-name": "Rectangle 3517",
    width: 2.416,
    height: 1.611,
    transform: "translate(33.345 22.626)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3518",
    "data-name": "Rectangle 3518",
    width: 2.416,
    height: 1.611,
    transform: "translate(33.345 26.654)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11081",
    "data-name": "Path 11081",
    d: "M16.232,30.978H14.621V20.507a.805.805,0,0,0-1.611,0V30.978H11.4V20.507a2.416,2.416,0,1,1,4.833,0Z",
    transform: "translate(-2.217 -3.519)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11082",
    "data-name": "Path 11082",
    d: "M25.232,30.978H23.621V20.507a.805.805,0,0,0-1.611,0V30.978H20.4V20.507a2.416,2.416,0,1,1,4.833,0Z",
    transform: "translate(-3.968 -3.519)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11083",
    "data-name": "Path 11083",
    d: "M34.232,30.978H32.621V20.507a.805.805,0,1,0-1.611,0V30.978H29.4V20.507a2.416,2.416,0,1,1,4.833,0Z",
    transform: "translate(-5.719 -3.519)",
    fill: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingDetails);
export default __webpack_public_path__ + "static/media/bankingDetails.d890238abfdef0ae003bdeef02b5a89a.svg";
export { ForwardRef as ReactComponent };